import '../../sass/blocks/resources.scss';

import Details from '../classes/Details';

(() => {
    const $resources = document.querySelectorAll('.resources');

    if (!$resources) return;

    $resources.forEach($resources => {
        const $productResources = $resources.querySelectorAll('.product-resource');
        const $finishResources = $resources.querySelectorAll('.finish-resource');

        const initProductResources = () => {
            if (!$productResources) return;

            $productResources.forEach($productResource => {
                new Details($productResource);
            });
        };

        const initFinishResources = () => {
            if (!$finishResources) return;

            $finishResources.forEach($finishResource => {
                new Details($finishResource);
            });
        };

        initProductResources();
        initFinishResources();
    });
})();
